export default "__VITE_ASSET__BTWfbxes__"